import { Component,OnInit,OnDestroy,AfterViewInit,ViewChild,ElementRef,Input } from "@angular/core";
import { FormBuilder,FormGroup,Validators,FormArray,AbstractControl } from "@angular/forms";
import { takeWhile } from "rxjs/operators";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
    FvmsCommonService
    ,FvmsApiAuthService
    ,FvmsApiCompanyService
} from "src/app/shared/service";
import {
    DtgActionType
    ,dtgCarTypeList
} from "src/app/shared/vo";

@Component({
    selector: "dtg-manage-company-form"
    ,templateUrl: "./dtg.manage.company.form.component.html"
    ,styleUrls: ["./dtg.manage.company.form.component.scss"]
    ,providers: []
})
export class DtgManageCompanyFormComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    currentUserInfo:any;
    formGroup:FormGroup;
    selectedCompanyInfo:any;
    dtgCarTypeList = dtgCarTypeList;
    submitted:boolean = false;
    @ViewChild('modalEtasLoginPw') modalEtasLoginPw:ElementRef;

    constructor(
        private formBuilder: FormBuilder
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsApiCompanyService:FvmsApiCompanyService
        ,private modalService: NgbModal
    ) {
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
    }

    ngOnInit() {
        this.initForm();
        this.fvmsApiCompanyService.subscribeCompanyEvent()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyEvent => {
                if(companyEvent){
                    let currentCompanyInfo = companyEvent.companyInfo;
                    let actionType = companyEvent.DtgActionType;
                    // console.log("currentCompanyInfo",currentCompanyInfo);
                    this.initForm();
                    switch(actionType){
                        case DtgActionType.update:
                        case DtgActionType.ok:
                            this.submitted = false;
                            // 상세정보 가져오기
                            this.fvmsApiCompanyService.getOneCompanyTree(currentCompanyInfo.companyId)
                                .pipe(takeWhile(() => this.isContinue))
                                .subscribe(apiResponse => {
                                    if(apiResponse.resultStatus === "ok"){
                                        this.selectedCompanyInfo = apiResponse.resultValue;
                                        this.formGroup.patchValue(this.selectedCompanyInfo);
                                        this.fvmsApiCompanyService.findAllCompanyLcs(currentCompanyInfo.companyId)
                                            .pipe(takeWhile(() => this.isContinue))
                                            .subscribe(apiResponse2 => {
                                                if(apiResponse2.resultStatus === "ok"){
                                                    let listLcs = apiResponse2.resultValue;
                                                    this.patchListLcs(listLcs);
                                                    this.sumCntLcs();
                                                }
                                            });
                                    }
                                })
                            break;
                        case DtgActionType.create:
                            this.formGroup.patchValue({
                                pCompanyId:currentCompanyInfo.companyId
                            });
                            break;
                        case DtgActionType.delete:
                            // 삭제 할거냐 팝업
                            break;
                        default:
                            break;
                    }
                }
            });
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    initForm(){
        this.formGroup = this.formBuilder.group({
            companyId:[
                ""
            ]
            ,pCompanyId:[
                ""
            ]
            ,companyNm:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,ownerNm:null
            ,ccd:null
            ,tid:null
            ,dtgEid:[
                ""
                ,[
                    Validators.required
                ]
            ]
            ,addr1:null
            ,addr2:null
            ,zipCode:null
            ,cntDrivePath:[
                0
                ,[
                    Validators.min(0)
                ]
            ]
            ,etasId:null
            ,etasPw:null
            ,cntDriverLcs:0
            ,cntCarLcs:0
            ,cntCar:0
            ,listCompanyLcs:new FormArray([])
            ,companyTypeId:null
            ,domainNm:null
            ,tel:null
            ,fax:null
            ,lat:null
            ,lng:null
            ,memo:null
            ,useYn:"Y"
        });
        dtgCarTypeList.forEach(item => {
            switch(item.dtgCarType){
                case "11":
                case "12":
                case "13":
                case "14":
                case "15":
                case "16":
                case "17":
                case "31":
                case "32":
                    this.f2.push(this.createCompanyLcs(item.dtgCarType,item.dtgCarTypeNm));
                    break;
                default:
                    break;
            }
        });
        // console.log("f",this.f);
    }

    get f() { return this.formGroup.controls; }
    get f2() { return this.formGroup.controls.listCompanyLcs as FormArray; }

    createCompanyLcs(dtgCarType:string,dtgCarTypeNm:string):FormGroup{
        return this.formBuilder.group({
            companyId:this.selectedCompanyInfo?.companyId || null
            ,dtgCarType:dtgCarType
            ,dtgCarTypeNm:dtgCarTypeNm
            ,cntDriverLcs:[
                0
                ,[
                    Validators.min(0)
                ]
            ]
            ,cntCarLcs:[
                0
                ,[
                    Validators.min(0)
                ]
            ]
            ,cntCar:[
                0
                ,[
                    Validators.min(0)
                ]
            ]
            ,useYn:false
        });
    }

    patchListLcs(listLcs:any[]){
        if(listLcs && this.f2.controls){
            listLcs.forEach((itemNew,idxNew) => {
                if(itemNew.useYn === "Y" || itemNew.useYn === "y"){
                    itemNew.useYn = true;
                }else{
                    itemNew.useYn = false;
                }
                this.f2.controls.forEach((itemTag,idxTag) => {
                    let dtgCarTypeTag = itemTag.get("dtgCarType").value;
                    if(dtgCarTypeTag === itemNew.dtgCarType){
                        itemTag.patchValue(itemNew);
                    }
                });
            });
        }
    }

    changeCompanyLcs(e,idx){
        // console.log("changeCompanyLcs",e.target.checked,idx);
        this.sumCntLcs();
    }

    changeCntDriverLcs(e,idx){
        this.sumCntLcs();
    }

    changeCntCarLcs(e,idx){
        this.sumCntLcs();
    }

    changeCntCar(e,idx){
        this.sumCntLcs();
    }

    sumCntLcs(){
        let sumCntDriverLcs = 0;
        let sumCntCarLcs = 0;
        let sumCntCar = 0;
        if(this.f2.controls){
            this.f2.controls.forEach((item,idx) => {
                // console.log("sumCntDriverLcs",item);
                sumCntDriverLcs += item.get("cntDriverLcs").value;
                sumCntCarLcs += item.get("cntCarLcs").value;
                sumCntCar += item.get("cntCar").value;
            });
        }
        this.formGroup.patchValue({
            cntDriverLcs:sumCntDriverLcs
            ,cntCarLcs:sumCntCarLcs
            ,cntCar:sumCntCar
        });
    }

    clickEtasPwReset(){
        let tmpCompanyInfo = {
            companyId:this.f.companyId.value
            ,dtgEid:this.f.dtgEid.value
            ,etasId:this.f.etasId.value
            ,etasPw:this.f.etasPw.value
        };
        this.fvmsApiCompanyService.updateEtasLoginPw(tmpCompanyInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.modalService.open(this.modalEtasLoginPw,{
                        centered:true
                        ,size: "sm"
                        ,backdrop:"static"
                        //windowClass: "dark-modal"
                        ,scrollable: true
                    }).result.then((result) => {
                        console.log("clickEtasPwReset",result);
                    },(reason) => {
                        console.log("clickEtasPwReset",reason);
                    });
                }
            });
    }

    clickSave(){
        this.onSubmit();
    }

    onSubmit(){
        this.submitted = true;
        // console.log("onSubmit",this.f);
        if (this.formGroup.invalid) {
            return;
        }

        let tmpCompanyInfo = {
            companyId:this.f.companyId.value
            ,pCompanyId:this.f.pCompanyId.value
            ,companyNm:this.f.companyNm.value
            ,ownerNm:this.f.ownerNm.value
            ,tid:this.f.tid.value
            ,ccd:this.f.ccd.value
            ,dtgEid:this.f.dtgEid.value
            ,addr1:this.f.addr1.value
            ,addr2:this.f.addr2.value
            ,zipCode:this.f.zipCode.value
            ,cntDrivePath:this.f.cntDrivePath.value
            ,etasId:this.f.etasId.value
            ,etasPw:this.f.etasPw.value
            ,cntDriverLcs:this.f.cntDriverLcs.value
            ,cntCarLcs:this.f.cntCarLcs.value
            ,cntCar:this.f.cntCar.value
            ,listCompanyLcs:[]
            ,companyTypeId:this.f.companyTypeId.value
            ,domainNm:this.f.domainNm.value
            ,tel:this.f.tel.value
            ,fax:this.f.fax.value
            ,lat:this.f.lat.value
            ,lng:this.f.lng.value
            ,memo:this.f.memo.value
            ,useYn:this.f.useYn.value
        };
        this.f2.controls.forEach(item => {
            let tmpLcs = {
                companyId:this.f.companyId.value
                ,dtgCarType:item.get("dtgCarType").value
                ,cntDriverLcs:item.get("cntDriverLcs").value
                ,cntCarLcs:item.get("cntCarLcs").value
                ,cntCar:item.get("cntCar").value
                ,useYn:item.get("useYn").value
            };
            tmpCompanyInfo.listCompanyLcs.push(tmpLcs);
        });
        this.fvmsApiCompanyService.upsertCompanyInfo(tmpCompanyInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    // console.log("upsertCompanyInfo",apiResponse.resultValue);
                    let companyEvent = {
                        companyInfo:tmpCompanyInfo
                        ,DtgActionType:DtgActionType.ok
                    };
                    this.fvmsApiCompanyService.setCompanyEvent(companyEvent);
                }
            });
    }
}